<!--
 * @Author: xing.huang
 * @Date: 2021-01-28 11:27:23
 * @LastEditTime: 2022-11-17 10:25:21
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster\iMaster-Web\src\views\FactoryModel\PrintStockDialog.vue
 * @
-->
<template>
	<div id="importOrderDialog">
		<el-dialog  title="批量打印"  :visible.sync="isShowDialog" :width="W?'60%':'70%'"  center :close-on-click-modal="false" @close="cancelAddDialog">
            <div style="display:flex">
                <div  class="select-all">
                    <el-checkbox v-model="selectPrint" style="align-self: center;" @change='selectPrintDataChange'></el-checkbox>
                </div>
                <div class="head-item"><span>库位名称</span></div>
                <div class="head-item">
                    <span>库区编码</span>
                    <i :class="computedClass(codeList)" style="margin: 0px 5px;cursor: pointer;position: relative;top: -1px;" @click="showCodeList=true"></i>
                    <div v-show="showCodeList" class="show-item">
                        <div class="show-item-sub">
                            <div style="display:flex">
                                <el-checkbox v-model="selectAll0">全选</el-checkbox>
                                <el-checkbox v-model="inverseSelect0">反选</el-checkbox>
                            </div>
                            <div class="checkbox-warp">
                                <el-checkbox style="display: block;" v-for="item in codeList" v-model="item.checked" :key="item.code" >{{item.code}}</el-checkbox>
                            </div>
                            <el-button type="primary" size="mini" @click="filterData">确定</el-button>
                            <el-button  size="mini"  @click="showCodeList=false">取消</el-button>
                        </div>
                    </div>
                </div>
                <div class="head-item">
                    <span>货列号</span>
                    <i :class="computedClass(areaList)" style="margin: 0px 5px;cursor: pointer;position: relative;top: -1px;" @click="showAreaList=true"></i>
                    <div v-show="showAreaList" class="show-item">
                        <div class="show-item-sub">
                            <div style="display:flex">
                                <el-checkbox v-model="selectAll1">全选</el-checkbox>
                                <el-checkbox v-model="inverseSelect1">反选</el-checkbox>
                            </div>
                            <div class="checkbox-warp">
                                <el-checkbox style="display: block;" v-for="item in areaList" v-model="item.checked" :key="item.code" >{{item.code}}</el-checkbox>
                            </div>
                            <el-button type="primary" size="mini" @click="filterData">确定</el-button>
                            <el-button  size="mini"  @click="showAreaList=false">取消</el-button>
                        </div>
                    </div>
                </div>
                <div class="head-item">
                    <span>列</span>
                    <i :class="computedClass(columnList)" style="margin: 0px 5px;cursor: pointer;position: relative;top: -1px;" @click="showColumnList=true"></i>
                    <div v-show="showColumnList" class="show-item" style="left:58px">
                        <div class="show-item-sub">
                            <div style="display:flex">
                                <el-checkbox v-model="selectAll2">全选</el-checkbox>
                                <el-checkbox v-model="inverseSelect2">反选</el-checkbox>
                            </div>
                            <div class="checkbox-warp">
                                <el-checkbox style="display: block;" v-for="item in columnList" v-model="item.checked" :key="item.code" >{{item.code}}</el-checkbox>
                            </div>
                            <el-button type="primary" size="mini" @click="filterData">确定</el-button>
                            <el-button  size="mini"  @click="showColumnList=false">取消</el-button>
                        </div>
                    </div>
                </div>
                <div class="head-item" style="border-right: 1px solid #EBEEF5;">
                    <span>层</span>
                    <i :class="computedClass(layerList)" style="margin: 0px 5px;cursor: pointer;position: relative;top: -1px;" @click="showLayerList=true"></i>
                    <div v-show="showLayerList" class="show-item" style="left:58px">
                        <div class="show-item-sub">
                            <div style="display:flex">
                                <el-checkbox v-model="selectAll3">全选</el-checkbox>
                                <el-checkbox v-model="inverseSelect3">反选</el-checkbox>
                            </div>
                            <div class="checkbox-warp">
                                <el-checkbox style="display: block;" v-for="item in layerList" v-model="item.checked" :key="item.code" >{{item.code}}</el-checkbox>
                            </div>
                            <el-button type="primary" size="mini" @click="filterData">确定</el-button>
                            <el-button  size="mini"  @click="showLayerList=false">取消</el-button>
                        </div>
                    </div>
                </div>
                <div class="scroll-width" v-if="list.length>16"></div>
            </div>
            <el-table class="task-list" :show-header ='false'  :data="list" border :maxHeight="577">  
                <el-table-column  width="36" >
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.isSelect"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="positionName" label="库位名称"  show-overflow-tooltip></el-table-column>
                <el-table-column prop="areaCode"   show-overflow-tooltip ></el-table-column>
                <el-table-column prop="cargoColumnNumber" label="人员"  show-overflow-tooltip></el-table-column>
                <el-table-column prop="positionColumn" label="设备"  show-overflow-tooltip></el-table-column>
                <el-table-column prop="positionLayer" label="设备"  show-overflow-tooltip></el-table-column>
            </el-table>
            
            <div style="text-align: center; margin-top:20px">
                <el-button type="primary" @click="printAll">确 定</el-button>
                <el-button  @click="cancelAddDialog">取 消</el-button>
            </div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'PrintStockDialog',
	props: {
        showPrintStock: Boolean,
        printData:Array,
        size:Number
	},
	data() {
        let that = this
		return {
            selectPrint:false,
            selectAll0:false,
            inverseSelect0:false,
            selectAll1:false,
            inverseSelect1:false,
            selectAll2:false,
            inverseSelect2:false,
            selectAll3:false,
            inverseSelect3:false,
            list:[],
            codeList:[],
            areaList:[],
            layerList:[],
            columnList:[],
            showCodeList:false,
            showAreaList:false,
            showLayerList:false,
            showColumnList:false,
            W:true,
            isShowDialog: false,
        }
    },
    mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        this.W = w>=1900?true:false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            this.W = w>=1900?true:false
        }
        
    },
    methods:{
        submitAddStock(){},
        cancelAddDialog(){
            this.list = []
            this.showCodeList = false
            this.showAreaList = false
            this.showLayerList = false
            this.showColumnList = false
            this.$parent.showPrintStock = false
        },
        selectPrintDataChange(ev){
            this.list.forEach(item=>{
                this.$set(item,'isSelect',ev)
            })
        },
        init(){
            let codeList = []
            let areaList = []
            let layerList = []
            let columnList = []
            this.list.forEach(item=>{
                if(!codeList.includes(item.areaCode)){
                    codeList.push(item.areaCode)
                }
                if(!areaList.includes(item.cargoColumnNumber)){
                    areaList.push(item.cargoColumnNumber)
                }
                if(!layerList.includes(item.positionLayer)){
                    layerList.push(item.positionLayer)
                }
                if(!columnList.includes(item.positionColumn)){
                    columnList.push(item.positionColumn)
                }
            })
            this.codeList =  codeList.map(item=>{
                return {checked:true,code:item}
            })
            this.areaList  = areaList.map(item=>{
                return {checked:true,code:item}
            }) 
            this.layerList =  layerList.map(item=>{
                return {checked:true,code:item}
            }) 
            this.columnList =  columnList.map(item=>{
                return {checked:true,code:item}
            }) 
            log(this.codeList)
        },
        filterData(){
            this.showCodeList = false
            this.showAreaList = false
            this.showLayerList = false
            this.showColumnList = false
            this.selectPrint = false
            let codeList = this.codeList.filter(item=>item.checked).map(item=>item.code)
            let areaList = this.areaList.filter(item=>item.checked).map(item=>item.code)
            let layerList =this.layerList.filter(item=>item.checked).map(item=>item.code)
            let columnList = this.columnList.filter(item=>item.checked).map(item=>item.code)
            let list = commonUtils.cloneObj(this.printData)
            this.list = list.filter(item=>codeList.includes(item.areaCode)&&areaList.includes(item.cargoColumnNumber)&&columnList.includes(item.positionColumn)&&layerList.includes(item.positionLayer))
        },
        printAll(){
            let list = this.list.filter(item=>item.isSelect)
            if(list.length==0){
                this.$message.warning('请选择需要打印的数据')
                return
            }
            localStorage.setItem("printType", "stock");
			let data = JSON.stringify(list);
			localStorage.setItem("printData", data);
            
            localStorage.setItem("size", this.size)
			let routeUrl = this.$router.resolve({
				path: "/printAll"
			});
            window.open(routeUrl.href, "_blank");
        },
        

        submitFilter(){
            
        },
        computedClass(list){
            let arr = ['el-icon-my-filter']
            if(list.some(item=>!item.checked)){
                arr.push('el-icon-my-filter-active')
            }
            return arr
        }
        
    },
    watch: {
		"showPrintStock": function (newVal, oldVal) {
            if(newVal){
                this.list = commonUtils.cloneObj(this.printData)
                log(this.list,123)
                this.init()
            }
			this.isShowDialog = this.showPrintStock;
        },
        codeList:{
            immediate:true,
            deep: true,
            handler(val){
                if(val.every(item=>item.checked)){
                    this.selectAll0 = true
                }
                if(val.every(item=>!item.checked)){
                    this.selectAll0 = false
                }
            }
        },
        selectAll0(val){
            this.codeList.forEach(item=>{
                item.checked = val
            })
        },
        inverseSelect0(val){
            this.codeList.forEach(item=>{
                item.checked = !item.checked
            })
        },
        areaList:{
            immediate:true,
            deep: true,
            handler(val){
                if(val.every(item=>item.checked)){
                    this.selectAll1 = true
                }
                if(val.every(item=>!item.checked)){
                    this.selectAll1 = false
                }
            }
        },
        selectAll1(val){
            this.areaList.forEach(item=>{
                item.checked = val
            })
        },
        inverseSelect1(val){
            this.areaList.forEach(item=>{
                item.checked = !item.checked
            })
        },
        columnList:{
            immediate:true,
            deep: true,
            handler(val){
                if(val.every(item=>item.checked)){
                    this.selectAll2 = true
                }
                if(val.every(item=>!item.checked)){
                    this.selectAll2 = false
                }
            }
        },
        selectAll2(val){
            this.columnList.forEach(item=>{
                item.checked = val
            })
        },
        inverseSelect2(val){
            this.columnList.forEach(item=>{
                item.checked = !item.checked
            })
        },
        layerList:{
            immediate:true,
            deep: true,
            handler(val){
                if(val.every(item=>item.checked)){
                    this.selectAll3 = true
                }
                if(val.every(item=>!item.checked)){
                    this.selectAll3 = false
                }
            }
        },
        selectAll3(val){
            this.layerList.forEach(item=>{
                item.checked = val
            })
        },
        inverseSelect3(val){
            this.layerList.forEach(item=>{
                item.checked = !item.checked
            })
        }
	},
}
</script>
<style scoped>
.column-warp{
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
}
.column{
    display: flex;
    
    border-right: 1px solid #ccc;
}
.column .item{
    flex: 1;
    height: 40px;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    text-align: center;
    line-height: 40px;
    
}
.title {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display: inline-block;
    text-align: right;
    width: 70px;
}

.value {
    display: inline-block
}
.head-item{
    flex: 1;
    border-top:1px solid #EBEEF5 ;
    border-left:1px solid #EBEEF5 ;
    height: 37px;
    line-height: 37px;
    position: relative;
}
.head-item >span{
    padding-left: 12px;
}
.show-item{
    position: absolute;
    top: 14px;
    left: 88px;
    z-index: 9999;
    background: rgba(231,254,255,0.85);
    border-radius: 10px;
}
.show-item .show-item-sub{
    padding: 10px;
    /* max-height: 560px;
    overflow: auto; */
}
.checkbox-warp{
    max-height: 510px;
    overflow: auto;
}
.select-all{
    width:35px;
    border-top: 1px solid #EBEEF5;
    border-left: 1px solid #EBEEF5;
    justify-content: center;
    align-content: center;
    display: flex;
}
.scroll-width{
    width: 14px;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
}
</style>
<style>
.checkbox-warp .el-button--mini, .checkbox-warp .el-button--mini.is-round {
    padding: 4px 7px;
}
</style>



// WEBPACK FOOTER //
// src/views/FactoryModel/PrintStockDialog.vue